import { getDagDashboardListMock } from '@/entities/dag/api/_internal/dagMockStore';
import { DAG_MATURITY_TYPES } from '@/entities/dag/domain/types';
import type { DagMaturity } from '@/entities/dag/domain/types';
import type { DataSourceItem, DataSourceListRequest, DataSourceListResponse } from '@/entities/datasource';

import { getConnectorsMockData } from './connectorMockStore';

const BRONZE_CONNECTOR_SITE_ALLOWLIST = new Set(['gsp', 'kmp']);

const toAssetUri = (dataInfo: {
  enterprise: string;
  site: string;
  area: string;
  process: string;
  unit: string;
  component: string;
  dataName: string;
}): string =>
  [
    dataInfo.enterprise,
    dataInfo.site,
    dataInfo.area,
    dataInfo.process,
    dataInfo.unit,
    dataInfo.component,
    dataInfo.dataName,
  ].join('/');

const getBronzeDataSources = (): DataSourceItem[] => {
  return getConnectorsMockData({ page: 1, pageSize: 1_000 })
    .items.filter((connector) => BRONZE_CONNECTOR_SITE_ALLOWLIST.has(connector.dataInfo.site))
    .map((connector) => {
      const assetUri = toAssetUri(connector.dataInfo);

      return {
        id: assetUri,
        name: assetUri,
        type: connector.type,
        description: connector.name,
      };
    });
};

const getDagDataSourcesByMaturity = (maturity: DagMaturity): DataSourceItem[] => {
  return getDagDashboardListMock({ maturity }).items.map((dag) => ({
    id: dag.dagUuid,
    name: dag.name,
    type: 'dag',
    description: dag.description ?? null,
  }));
};

export const getDagDataSourcesMockData = ({ maturity }: DataSourceListRequest): DataSourceListResponse => {
  const items =
    maturity === DAG_MATURITY_TYPES.BRONZE
      ? getBronzeDataSources()
      : maturity === DAG_MATURITY_TYPES.SILVER
        ? getDagDataSourcesByMaturity(DAG_MATURITY_TYPES.BRONZE)
        : maturity === DAG_MATURITY_TYPES.GOLD
          ? getDagDataSourcesByMaturity(DAG_MATURITY_TYPES.SILVER)
          : [];

  return {
    items,
    total: items.length,
  };
};
